module.exports = __webpack_public_path__ + "static/img/__9369.187ea67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9369.jpg
// module id = kbPM
// module chunks = 0